import Modal from "react-bootstrap/Modal";
import circularClose from "asset/images/circular-close.svg"

function RejectInvoiceModal({show, setShow, isLoading, onClick}) {
    const closeModal = () => {
        setShow(!show);
  };
  // const navigate = useNavigate()

  return (
      <Modal
          show={show}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="border-0 "
          onHide={closeModal}
      >
          <Modal.Body
              style={{
                  borderRadius: "16px",
                  padding: "0px",
                  border: "none",
              }}
          >
              <div className="flex items-start gap-4 px-4 py-4">
                  <div>
                      <img src={circularClose} alt="Close icon" />
                  </div>

                  <div>
                      <div className="flex items-center justify-between">
                          <h5 className="text-xl font-semibold text-gray-90">
                              Reject this invoice?
                          </h5>

                          <span
                              className="cursor-pointer material-icons"
                              style={{ color: "#667085" }}
                              onClick={closeModal}
                          >
                              close
                          </span>
                      </div>
                      <p className="text-sm font-normal text-gray-70">
                          Rejecting this invoice will notify the sender, remove it from your end,
                          and you won’t be able to make payments.
                      </p>
                  </div>
              </div>
              <div
                  className="flex items-center justify-end p-3 gap-x-5"
                  style={{
                      borderTop: "1px solid #E7E9FB",
                  }}
              >
                  <button
                      onClick={closeModal}
                      className="hover:opacity-90 mt-0 sm:!mt-0 flex items-center gap-2 text-gray-10 rounded-lg py-[10px] px-4 text-sm"
                  >
                      Cancel
                  </button>
                  <button
                      disabled={isLoading}
                      type="button"
                      onClick={onClick}
                      className="hover:opacity-90 !bg-danger-10 mt-0 sm:!mt-0 flex items-center gap-2 text-white rounded-lg py-[10px] px-4 text-sm"
                  >
                      {isLoading ? "Loading..." : "Reject invoice"}
                  </button>
              </div>
          </Modal.Body>
      </Modal>
  );
}

export default RejectInvoiceModal;
